import { render, staticRenderFns } from "./AddPaymentPreferenceComponent.vue?vue&type=template&id=71ed31ef&"
import script from "./AddPaymentPreferenceComponent.vue?vue&type=script&lang=js&"
export * from "./AddPaymentPreferenceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports